module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-woman-40@2x_6828bba929f00c4d4cb5f8a8eeab8870.png";